// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Billing page components
import Shop from "layouts/retailerShops/components/Shop";

function ShopsList({shops, onEditClick}) {
  return (
    <Card id="retailer-shops">
      <MDBox pt={1} pb={2} px={2}>
        <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
          {shops.map((shop) => (
              <Shop
              key={shop["id"]}
              name={shop["shop_name"]}
              category={shop["shop_category"]}
              address={shop["shop_address"]}
              city={shop["shop_city"]}
              country={shop["shop_country"]}
              createdAt={shop["created_at"]}
              updatedAt={shop[["updated_at"]]}
              logoId={shop["logo_id"]}
              onEditClick={() => {onEditClick(shop)}}
            />

          ))}
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default ShopsList;
